import React from "react";

// SG-2164: shared "Breakdown by member" renderer — each row's progress bar is that member's
// share of the total across all rows (not a fixed/absolute scale), so bars are only comparable
// within the same widget, not across widgets.
const MemberBreakdownList = ({ rows }) => {
  if (!rows?.length) return null;
  const total = rows.reduce((sum, r) => sum + (r.count || 0), 0);
  return (
    <div className="widgetCardMemberBreakdown">
      {rows.map(r => {
        const pct = total > 0 ? Math.min(100, Math.round(((r.count || 0) / total) * 100)) : 0;
        return (
          <div key={r.memberId} className="widgetCardMemberBreakdownRow">
            <div className="widgetCardMemberBreakdownHeader">
              <span className="widgetCardMemberBreakdownName">{r.name || r.memberId}</span>
              <span className="widgetCardMemberBreakdownValue">{r.count}</span>
            </div>
            <div className="widgetCardMemberBreakdownBarTrack">
              <div className="widgetCardMemberBreakdownBarFill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MemberBreakdownList;
